import IntsSerializer from './binaryData/IntsSerializer';
import MltSerializer from './binaryData/MltSerializer';
import RttSerializer from './binaryData/RttSerializer';
import type { SerializerRegistry } from '@visualizer/types';

const version = 'v0_0_14';

const v0_0_14: SerializerRegistry = {
    version,
    binary: {
        IntsSerializer: new (IntsSerializer as any)(version),
        RttSerializer: new (RttSerializer as any)(version),
        MltSerializer: new (MltSerializer as any)(version),
    },
};

export default v0_0_14;
